import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

interface CitationSourcePillProps extends Omit<BoxProps, 'onClick' | 'onKeyDown'> {
	label: string | number;
	onOpen: (event: React.MouseEvent | React.KeyboardEvent) => void;
	onClick?: React.MouseEventHandler<HTMLElement>;
	onKeyDown?: React.KeyboardEventHandler<HTMLElement>;
}

const CITATION_SOURCE_PILL_HEIGHT = '20px';
const CITATION_SOURCE_PILL_FONT_SIZE = { base: '10px', md: '12px' } as const;

const CitationSourcePill = React.forwardRef<HTMLSpanElement, CitationSourcePillProps>(
	function CitationSourcePill(props, ref) {
		const { label, onOpen, onClick, onKeyDown, ...rest } = props;

		return (
			<Box
				ref={ref}
				as="span"
				className="group"
				role="button"
				tabIndex={0}
				display="inline-flex"
				alignItems="center"
				justifyContent="center"
				h={CITATION_SOURCE_PILL_HEIGHT}
				minW={CITATION_SOURCE_PILL_HEIGHT}
				px={1}
				borderRadius="full"
				bg="bg.muted"
				color="fg.muted"
				fontSize={CITATION_SOURCE_PILL_FONT_SIZE}
				fontWeight="medium"
				lineHeight="1"
				cursor="pointer"
				_groupHover={{ bg: 'brand.muted', color: 'brand.fg' }}
				_focusVisible={{
					outline: '2px solid',
					outlineColor: 'brand.fg',
					outlineOffset: '2px',
				}}
				onClick={(event) => {
					onClick?.(event);
					onOpen(event);
				}}
				onKeyDown={(event) => {
					onKeyDown?.(event);
					if (event.key === 'Enter' || event.key === ' ') {
						onOpen(event);
					}
				}}
				{...rest}
			>
				{label}
			</Box>
		);
	},
);

export default CitationSourcePill;
